import { useMutation } from '@tanstack/react-query';
import { post } from '../../utils/networking';

interface InstallSlackChannelParams {
  trustpulseTeamId: number;
  slackChannelId: string;
  slackWorkspaceId: number;
}

interface InstallSlackChannelResponse {
  success: boolean;
  channelName: string;
  distributionChannelId: number;
}

const installSlackChannel = async (params: InstallSlackChannelParams): Promise<InstallSlackChannelResponse> => {
  return post<InstallSlackChannelResponse>('/api/integrations/slack/install', params);
};

export const useInstallSlackChannel = () => {
  return useMutation({
    mutationFn: installSlackChannel,
  });
};
